<template>
  <div class="data-state-message" :class="stateClass">
    <!-- 로딩 상태 -->
    <div v-if="state === 'loading'" class="state-content loading">
      <div class="loading-spinner"></div>
      <p>{{ loadingMessage }}</p>
    </div>

    <!-- 에러 상태 -->
    <div v-else-if="state === 'error'" class="state-content error">
      <p>{{ errorMessage }}</p>
<!--      <button v-if="showRetry" @click="$emit('retry')" class="retry-button">-->
<!--        다시 시도-->
<!--      </button>-->
    </div>

    <!-- 빈 데이터 상태 -->
    <div v-else-if="state === 'empty'" class="state-content empty">
      <p>{{ emptyMessage }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataStateMessage',
  props: {
    state: {
      type: String,
      required: true,
      validator: (value) => ['loading', 'error', 'empty'].includes(value)
    },
    loadingMessage: {
      type: String,
      default: '데이터를 불러오는 중...'
    },
    errorMessage: {
      type: String,
      default: '데이터를 불러오는 중 오류가 발생했습니다.'
    },
    emptyMessage: {
      type: String,
      default: '데이터가 없습니다.'
    },
    showRetry: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    stateClass() {
      return `state-${this.state}`;
    }
  }
};
</script>

<style scoped lang="scss">
.data-state-message {
  padding: 80px 36px;
  text-align: center;
  width: 100%;
  max-width: 500px;
  margin: 0 auto;

  .state-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;

    p {
      font-family: 'Noto Sans KR', sans-serif;
      font-weight: 350;
      font-size: 16px;
      line-height: 28px;
      margin: 0;
    }
  }

  // 로딩 상태
  &.state-loading {
    .state-content {
      p {
        color: #0056AA;
      }
    }

    .loading-spinner {
      width: 40px;
      height: 40px;
      border: 4px solid #f3f3f3;
      border-top: 4px solid #0056AA;
      border-radius: 50%;
      animation: spin 1s linear infinite;
    }

    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  }

  // 에러 상태
  &.state-error {
    .state-content {
      p {
        color: #d32f2f;
      }
    }

    .retry-button {
      padding: 12px 32px;
      font-family: 'Noto Sans KR', sans-serif;
      font-weight: 500;
      font-size: 15px;
      color: #FFFFFF;
      background-color: #0056AA;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      transition: background-color 0.3s;

      &:hover {
        background-color: #003d7a;
      }

      &:active {
        background-color: #002952;
      }
    }
  }

  // 빈 데이터 상태
  &.state-empty {
    .state-content {
      p {
        color: #666666;
      }
    }
  }

  // 반응형
  @media (max-width: 768px) {
    padding: 60px 20px;

    .state-content {
      gap: 16px;

      p {
        font-size: 15px;
        line-height: 26px;
      }
    }

    &.state-loading {
      .loading-spinner {
        width: 32px;
        height: 32px;
        border-width: 3px;
      }
    }

    &.state-error {
      .retry-button {
        padding: 10px 24px;
        font-size: 14px;
      }
    }
  }

  @media (max-width: 450px) {
    padding: 40px 15px;

    .state-content {
      gap: 12px;

      p {
        font-size: 14px;
        line-height: 24px;
      }
    }

    &.state-loading {
      .loading-spinner {
        width: 28px;
        height: 28px;
      }
    }
  }
}
</style>